import React from 'react'
import { Location } from '@reach/router'
import { Subscribe } from 'bey-fix'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import DemoBanner from '../DemoBanner'

import accounts from '../state/accounts'
import { getVersionString } from '../helpers/version'
import { stripLocalePrefix } from '../helpers/locale'

export function Footer({ showDemoBanner = false }) {
  const { t } = useTranslation()
  return (
    <footer
      className={cx(
        'w-100 mw9 center ph3 ph4-ns f7 pt3 lh-copy',
        showDemoBanner ? 'pb5' : 'pb3'
      )}
      role="contentinfo"
    >
      <div className="flex flex-column flex-row-ns items-end justify-end">
        {[
          {
            href: 'https://wisehome.dk',
            title: 'Wise Home',
          },
          {
            href: 'mailto:info@wisehome.dk',
            title: 'info@wisehome.dk',
          },
          {
            href: 'tel:+4520693501',
            title: '+45 20 69 35 01',
          },
          {
            href: 'https://wisehome.dk/privatlivspolitik',
            title: t('footer.privacyPolicy'),
            noprint: true,
          },
        ].map(({ href, title, noprint = false }) => (
          <a
            key={href}
            href={href}
            target={/^(mailto:|tel:)/.test(href) ? null : '_blank'}
            rel="noopener noreferrer"
            className={cx(
              'link orange ml2 ml3-l nowrap',
              noprint && 'no-print'
            )}
          >
            {title}
          </a>
        ))}
        <span className="silver ml2 ml3-l nowrap">{getVersionString()}</span>
        <DemoBanner isVisible={showDemoBanner} />
      </div>
    </footer>
  )
}

export default function SubscribedFooter(props) {
  return (
    <Location>
      {({ location }) => (
        <Subscribe to={accounts}>
          {(accounts) => {
            const pathname = stripLocalePrefix(location.pathname)
            const isPasswordResetPage = /^\/password-reset\//.test(pathname)
            const isAccountActivationPage = /^\/activate/.test(pathname)
            return (
              <Footer
                {...props}
                showDemoBanner={
                  !accounts.activeApiKey &&
                  !accounts.showLoginModal &&
                  !isPasswordResetPage &&
                  !isAccountActivationPage
                }
              />
            )
          }}
        </Subscribe>
      )}
    </Location>
  )
}
